// extracted by mini-css-extract-plugin
module.exports = {"switch":"Checkbox_switch__2AvBq","slider":"Checkbox_slider__rU0_3"};